import { autorun, extendObservable } from 'mobx';
import { api } from '../service/api.service';

class ConfigStore {
  constructor() {
    extendObservable(this, {
      lettersEnabled: false,
      lettersEnabledForCondo: false,
      rentContractDocumentsEnabled: false,
      ocInspectionEnabled: false,
      ocCalculationsEnabled: false,
      pmOcInspectionEnabled: false,
      operationalCostPrepaymentEnabled: false,
      consultationsBookingEnabled: false,
      verificationMethodEmail: false,
      tenantNotificationsEnabled: false,
      adventCalendarEnabled: false,
      adventCalendarUrl: '',
      heatingAndEnergyEnabled: false,
      loyaltyEnabled: false,
      srAmendmentImagesEnabled: false,
      digitalFormsEnabled: false,
      rentAccountEnabled: false,
    });
    autorun(() => {
      this.getConfig();
    });
  }

  async getConfig() {
    try {
      const response = await api.get('/api/config');
      const data = response.data;
      for (const key in data.settings) {
        this[key] = data.settings[key];
      }
    } catch (error) {
      console.error(error);
    }
  }
}

export default ConfigStore;
